export default "__VITE_ASSET__BGhmNWbJ__"